import script from "./FilterByCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterByCategory.vue?vue&type=script&lang=ts&setup=true"

import "./FilterByCategory.vue?vue&type=style&index=0&id=266f1956&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-266f1956"]])

export default __exports__